<template>
  <div />
</template>

<script>

/**
 * Vue: Content doorways (content-doorways)
 * -----------------------------------------------------------------------------
 * Content Cards.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import { mapState } from 'vuex'
import Splide from '@splidejs/splide'
import { values as breakpoints } from '~/config/breakpoints'
export default {
  name: 'ContentDoorways',

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        slideCount: 0,
      }),
    },
  },

  data() {
    return {

    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  mounted() {
    this.container = document.querySelector(`#vue-element .section-${this.liquid.sectionId}`)
    this.carousel = this.container.querySelector('.splide')
    this.cards = this.carousel.querySelectorAll('.content-doorways__card')
    this.slideCountContainer = this.carousel.querySelector('.js-splide-counter')
    this.createCarousel()
    this.bindEventListeners()
  },

  methods: {

    /**
     * Bind event listeners.
     */
    bindEventListeners() {
      if (!this.cards.length > 0) {
        return
      }

      this.cards.forEach((card) => {
        const videoPlayer = card.querySelector('.responsive-video__video')

        if (videoPlayer) {
          card.addEventListener('mouseenter', () => {
            videoPlayer.play()
          })

          card.addEventListener('mouseleave', () => {
            videoPlayer.pause()
            videoPlayer.currentTime = 0
          })
        }
      })
    },

    /**
     * Create carousel.
     */
    createCarousel() {
      this.splide = new Splide(this.carousel, {
        gap: 24,
        perPage: this.slideCount === 3 ? 3 : 2,
        perMove: 1,
        focus: 0,
        omitEnd: true,
        pagination: false,
        keyboard: true,
        breakpoints: {
          [breakpoints.l]: {
            perPage: 1.125,
            perMove: 1,
            focus: 0,
            omitEnd: true,
          },
        },
      })

      if (this.slideCountContainer) {
        this.bindSplideEvents()
      }

      this.splide.mount()
      this.setInitialSlideCount()
    },

    /*
      Set splide event listeners
    */
    bindSplideEvents() {
      this.splide.on('moved', (index) => {
        const slideIndex = index + 1
        this.currentSlide = slideIndex
        this.slideCountContainer.innerHTML = `${this.currentSlide}/${this.liquid.slideCount}`
      })

      /*
        Check if screensize is desktop.
        Set index back to one when back to mobile view
      */
      this.splide.on('resize', () => {
        if (this.isMobile) {
          return
        }

        this.currentSlide = 1
        this.slideCountContainer.innerHTML = `${this.currentSlide}/${this.liquid.slideCount}`
      })
    },

    /**
     * Set initial slide count.
     */
    setInitialSlideCount() {
      if (this.slideCountContainer) {
        this.currentSlide = 1
        this.slideCountContainer.innerHTML = `${this.currentSlide}/${this.liquid.slideCount}`
      }
    },
  },
}
</script>

<style lang="scss">
@import './content-doorways';
</style>
